import React from "react";
import styled from "styled-components";
import loadable from "@loadable/component";

import { breakpoints, fontFamily, sectionRhythm } from "../../../theme";
import { PageSection } from "../../components/layout/layout-styles";
import FaqSkeleton from "./faq-skeleton";

const FaqContent = loadable(() => import("./faq-content"));

const Section = styled(PageSection)`
  margin: 0 auto;
  width: 94%;
  max-width: 1040px;
  /* Extra bottom space before Contact - gap below reads tighter than above */
  padding-bottom: ${sectionRhythm.paddingY.mobile * 2}px;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    padding-bottom: ${sectionRhythm.paddingY.desktop * 2}px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: ${sectionRhythm.paddingY.mobile}px;
  text-align: center;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    margin-bottom: ${sectionRhythm.paddingY.desktop}px;
    text-align: start;
  }
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${fontFamily.bold};
  font-size: 32px;
  line-height: 102%;

  @media only screen and (min-width: ${breakpoints.desktop}) {
    font-size: 40px;
  }
`;

const Supporting = styled.p`
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #374151;
`;

export default function FaqSection() {
  return (
    <Section name="faq" as="section" aria-labelledby="faq-heading">
      <Header>
        <Heading id="faq-heading">Frequently asked questions</Heading>
        <Supporting>
          Practical answers about rates, engagement, and how we work together.
        </Supporting>
      </Header>

      <FaqContent fallback={<FaqSkeleton />} />
    </Section>
  );
}
